import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './RfiModal.css';
import { Enterprise } from 'domain/enterprise';
import { initRfiModal } from 'components/admin/projects/details/project-rfi-log/store/actions';
import FormModal from 'components/shared/modal/FormModal';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import RfiForm from 'components/admin/projects/details/project-rfi-log/RfiForm';
import RfiQuestions from 'components/admin/projects/details/project-rfi-log/RfiQuestions';
import RfiActions from 'components/admin/projects/details/project-rfi-log/RfiActions';
import RfiDetails from 'components/admin/projects/details/project-rfi-log/RfiDetails';

class RfiModal extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    contribType: PropTypes.string.isRequired,
    project: PropTypes.shape({}).isRequired,
    number: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
    show: PropTypes.bool.isRequired,
    currentRfi: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    gcAcceleration: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    props.dispatch(initRfiModal());
  }

  render() {
    const readOnly =
      this.props.readOnly || Enterprise.primary(this.props.contribType);
    return (
      <FormModal
        className="rfi-modal"
        show={this.props.show}
        onClose={this.props.handleClose}
        subTitle={
          <RouteTitle
            titles={[
              'Projects',
              this.props.project.name,
              `RFI ${this.props.number}`,
            ]}
          />
        }
      >
        <div className="rfi-body">
          {readOnly ? (
            <RfiDetails currentRfi={this.props.currentRfi} />
          ) : (
            <RfiForm
              currentUser={this.props.currentUser}
              contribType={this.props.contribType}
              project={this.props.project}
              currentRfi={this.props.currentRfi}
            />
          )}

          <hr />

          <RfiQuestions
            currentUser={this.props.currentUser}
            contribType={this.props.contribType}
            project={this.props.project}
            currentRfi={this.props.currentRfi}
            readOnly={readOnly}
            modalReadOnly={this.props.readOnly}
            gcAcceleration={this.props.gcAcceleration}
          />
        </div>

        <hr />

        <RfiActions
          currentUser={this.props.currentUser}
          contribType={this.props.contribType}
          project={this.props.project}
          currentRfi={this.props.currentRfi}
          readOnly={this.props.readOnly}
          gcAcceleration={this.props.gcAcceleration}
          handleClose={this.props.handleClose}
        />
      </FormModal>
    );
  }
}

export default connect()(RfiModal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/RfiModal.js